function addStyles (win, styles) {
styles.forEach(style => {
let link = win.document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute('href', style);
win.document.getElementsByTagName('head')[0].appendChild(link);
});
}

const VueHtmlToPaper = {
install (Vue, options = {}) {
Vue.mixin({
methods: {
$htmlToPaper (el, cb = () => true) {
let {
name = '_blank',
specs = ['fullscreen=yes','titlebar=yes', 'scrollbars=yes'],
replace = true,
styles = []
} = options;
specs = !!specs.length ? specs.join(',') : '';

const element = document.getElementById(el);

if(!element) {
alert(`Element to print #${el} not found!`);
return;
}

const url = '';
const win = window.open(url, name, specs, replace);

win.document.write(`
<html>
<head>
    <title>${document.title}</title>
    <style type="text/css">
.form-control:disabled, .form-control[disabled] {
    color: black !important;
}
.form-control, .form-control {
    color: black !important;
}
.text-black {
    color: black;
}
.p-center {
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0;
}
.bold-text {
    font-weight: bold;
}
::placeholder { /* Firefox, Chrome, Opera */
    color: black;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: black;
}
::-ms-input-placeholder { /* Microsoft Edge */
    color: black;
}
</style>
</head>
<body>
${element.innerHTML}
</body>
</html>
`);

addStyles(win, styles);

setTimeout(() => {
win.document.close();
win.focus();
win.print();
win.close();
cb();
}, 1000);
return true;
}
}
});
}
}

export default VueHtmlToPaper;
